/**
 * Clasifica el mensaje de error de la respuesta normalizada del servicio
 * y retorna el mensaje apropiado para mostrar al usuario.
 *
 * @param {string} mensaje - Mensaje de la respuesta normalizada
 * @returns {string} Mensaje de error clasificado para el usuario
 */
export function clasificarErrorOrden(mensaje) {
  if (!mensaje) {
    return 'Ocurrió un error en el servidor. Por favor, intenta nuevamente más tarde.';
  }

  // Error de conexión / red
  if (mensaje.toLowerCase().includes('conexión')) {
    return 'Error de conexión. Verifica tu conexión a internet e intenta nuevamente.';
  }

  // Error de servidor (HTTP 500)
  if (mensaje.toLowerCase().includes('servidor')) {
    return 'Ocurrió un error en el servidor. Por favor, intenta nuevamente más tarde.';
  }

  // Orden no encontrada u otro error del backend (HTTP 422, etc.)
  return mensaje || 'No se encontró la orden especificada. Verifica el número e intenta nuevamente.';
}
